<template>
  <div class="customerOrderDetailPage">
    <el-tabs
      v-model="activeName"
      type="border-card"
      :before-leave="onBeforeLeave"
    >
      <el-tab-pane
        :label="$l('INDEX.order_tab_base_information') || '基本信息'"
        name="base"
      >
        <OrderInfo
          ref="base"
          :changeOrderCode="params.code"
          :disabled="isDisableEditForm"
        />
        <div
          class="d-flex justify-content-end mt-2 mb-2"
          v-if="!isDisableEditForm"
        >
          <el-button type="primary" size="small" @click="save()">{{
            $l('INDEX.btn_save') || '保存'
          }}</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_order_goods') || '产品信息'"
        name="goods"
        lazy
      >
        <OrderGoods
          :changeOrderCode="params.code"
          :disabled="isDisableEditForm"
          @reloadOrderInfo="() => $refs.base.reloadOrderInfo()"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_demand_fabric') || '产品面料'"
        name="demandFabric"
        lazy
      >
        <DemandFabric
          :changeOrderCode="params.code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_tech_doc') || '工艺说明'"
        name="techDoc"
        lazy
      >
        <TechDoc :changeOrderCode="params.code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.tab_doc') || '订单文件'"
        name="orderDoc"
        lazy
      >
        <OrderDoc
          :changeOrderCode="params.code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_demand_material') || '产品辅料'"
        name="demandMabric"
        lazy
      >
        <DemandMaterial
          :changeOrderCode="params.code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.tab_goods_package_size') || '产品包装'"
        name="goodsPackage"
        lazy
      >
        <GoodsPackage
          :changeOrderCode="params.code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_demand_package') || '外包装箱'"
        name="demandPackage"
        lazy
      >
        <DemandPackage
          :changeOrderCode="params.code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.tab_demand_packing') || '装箱方案'"
        name="demandPacking"
        lazy
      >
        <DemandPacking
          :changeOrderCode="params.code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_sample_request') || '样品需求'"
        name="sampleRequest"
        lazy
      >
        <Proofing
          :changeOrderCode="params.code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_delivery_batch') || '交货批次'"
        name="batch"
        lazy
      >
        <OrderBatch
          :changeOrderCode="params.code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_inspection_requirements') || '验货要求'"
        name="checkRequest"
        lazy
      >
        <OrderInspection
          :changeOrderCode="params.code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import OrderInfo from '../components/info'
import OrderGoods from '../components/goods'
import DemandFabric from '../components/demand-fabric'
import TechDoc from '../components/tech-doc'
import OrderDoc from '../components/order-doc'
import DemandMaterial from '../components/demand-material'
import GoodsPackage from '../components/goods-package'
import DemandPackage from '../components/demand-package'
import DemandPacking from '../components/demand-packing'
import Proofing from '../components/proofing'
import OrderBatch from '../components/batch'
import OrderInspection from '../components/inspection'

export default {
  name: 'order-changeOrderDetail',
  components: {
    OrderInfo,
    OrderGoods,
    DemandFabric,
    TechDoc,
    OrderDoc,
    DemandMaterial,
    GoodsPackage,
    DemandPackage,
    DemandPacking,
    Proofing,
    OrderBatch,
    OrderInspection,
  },
  data() {
    return {
      activeName: 'base',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  methods: {
    onBeforeLeave(val) {
      if (val === 'base') {
        return true
      }
      if (!this.params.code || this.pageType === 'add') {
        this.$message.warning(
          this.$l('INDEX.tips_save_basicinfo_first') || '请先保存基本信息!'
        )
        return false
      }
    },
    save() {
      this.$refs.base.save()
    },
  },
}
</script>
